module.exports = __webpack_public_path__ + "static/nash-a74d7da58f469009ab82e7e646fb9be6.jpg";